export default "__VITE_ASSET__RBQMv3J5__"